<template>
    <div class="container">
        <div class="header">个人信息</div>
        <div class="body">
            <div class="avatar">
                <upload
                    title="头像"
                    :url="userInfo.headPortrait || avatarDefault"
                    width="68"
                    :limit="2"
                    again
                    crop
                    clearable
                    radius="34"
                    placeholder=""
                    @update="handleAvatarSuccess"
                ></upload>
            </div>
            <div class="info-item">
                <div class="label">姓名</div>
                <div class="value">{{ userInfo.nickName }}</div>
            </div>
            <div class="info-item">
                <div class="label">性别</div>
                <div class="value">
                    <div>{{ genderEnum[userInfo.gender] }}</div>
                    <div class="value_btn" @click="handleEdit('gender')">
                        修改性别
                    </div>
                </div>
            </div>
            <div class="info-item">
                <div class="label">手机号</div>
                <div class="value">
                    <div>{{ userInfo.phone }}</div>
                    <!-- 如果是租户账号，禁止修改手机号 -->
                    <div
                        v-if="userInfo.tenantDefaultFlag !== 1"
                        class="value_btn"
                        @click="handleEdit('phone')"
                    >
                        修改手机号
                    </div>
                </div>
            </div>
            <div class="info-item">
                <div class="label">密码</div>
                <div class="value">
                    <div>************</div>
                    <div class="value_btn" @click="handleEdit('password')">
                        修改密码
                    </div>
                </div>
            </div>
        </div>
        <!-- 编辑更新的弹窗 -->
        <edit-dialog
            :visible.sync="dialogEditOptions.visible"
            :type="dialogEditOptions.type"
            @on-success="handleFresh"
        />
    </div>
</template>
<script>
import Upload from '@/components/Upload';
import EditDialog from './components/dialog-edit.vue';
import { genderEnum } from './constants';
import { ApiUpdateUserInfo } from '@/api/user';
import { mapGetters } from 'vuex';
import { avatarDefault } from '@/common/config';
export default {
    name: 'Profile',
    components: {
        Upload,
        EditDialog
    },
    data() {
        return {
            avatarDefault,
            genderEnum,
            // 编辑更新的弹窗
            dialogEditOptions: {
                visible: false,
                type: ''
            },
            // 修改手机号/密码之前的验证弹窗
            dialogValidateOptions: {
                visible: false,
                type: ''
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    methods: {
        // 图片上传完成
        handleAvatarSuccess(imgUrl) {
            const obj = {
                headPortrait: imgUrl
            };
            ApiUpdateUserInfo(obj).then(res => {
                const { message = '修改成功' } = res;
                this.$store.dispatch('set_userInfo');
                this.$message.success(message);
            });
        },
        // 修改
        handleEdit(type) {
            this.dialogEditOptions = {
                visible: true,
                type
            };
        },
        // 刷新
        handleFresh() {
            this.$store.dispatch('set_userInfo');
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    padding: 16px;
    .header {
        font-size: 20px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
    }
    .body {
        margin: 0 auto;
        width: 400px;
        .avatar {
            margin-bottom: 67px;
        }
        .info-item {
            display: flex;
            height: 14px;
            font-size: 14px;
            color: #333333;
            line-height: 14px;
            margin-bottom: 20px;
            .label {
                flex-shrink: 0;
                width: 42px;
                text-align: right;
                margin-right: 23px;
            }
            .value {
                display: flex;
                flex-grow: 1;
                justify-content: space-between;
            }
            .value_btn {
                cursor: pointer;
                color: #0772eb;
            }
        }
    }
}
</style>
